import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SocialBlockLinkedinIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SocialBlockLinkedin",
    children: /*#__PURE__*/_jsx("path", {
      d: "M29.99 24.75A5.31 5.31 0 0 1 24.76 30H7.24c-2.88-.04-5.21-2.37-5.24-5.24V7.25A5.31 5.31 0 0 1 7.23 2h17.5c2.9.04 5.24 2.4 5.24 5.3v17.45zM8.45 6.7c-.06 0-.14-.01-.22-.01a2.19 2.19 0 1 0 0 4.38c.08 0 .15 0 .22-.01.06 0 .14.01.22.01a2.19 2.19 0 1 0 0-4.38c-.08 0-.15 0-.22.01m2.12 18.73V12.8H6.33v12.63zm15.13 0v-7.25c0-3.88-2.12-5.69-4.86-5.69h-.12c-1.56 0-2.93.84-3.66 2.1v.02l-.01-1.8h-4.23s.06 1.19 0 12.65h4.24v-7.25c0-.31.05-.62.15-.9v.02c.32-.88 1.14-1.51 2.11-1.54 1.53 0 2.12 1.15 2.12 2.86v6.76h4.24z"
    })
  }));
};
SocialBlockLinkedinIcon.displayName = 'SocialBlockLinkedinIcon';